import { render, staticRenderFns } from "./MenuSection.vue?vue&type=template&id=cf4f7602&scoped=true&"
import script from "./MenuSection.vue?vue&type=script&lang=js&"
export * from "./MenuSection.vue?vue&type=script&lang=js&"
import style0 from "./MenuSection.vue?vue&type=style&index=0&id=cf4f7602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4f7602",
  null
  
)

export default component.exports